import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/platform/AuthContext";
import { ProtectedRoute, PublicOnlyRoute } from "@/platform/routes";
import AuthCallback from "@/platform/AuthCallback";
import Signup from "@/platform/pages/Signup";
import Verify from "@/platform/pages/Verify";
import Account from "@/platform/pages/Account";
import Workspace from "@/platform/pages/Workspace";
import Login from "@/platform/pages/Login";
import Forgot from "@/platform/pages/Forgot";
import { Terms, Privacy } from "@/platform/pages/Legal";
import AppLayout from "@/platform/app/AppLayout";
import Overview from "@/platform/app/Overview";
import ProjectView from "@/platform/app/ProjectView";
import Integrations from "@/platform/app/Integrations";
import Inbox from "@/platform/app/Inbox";
import Placeholder from "@/platform/app/Placeholder";
import DemoHarness from "@/components/DemoHarness";
import ReviewerEntry from "@/platform/pages/ReviewerEntry";
import JoinWorkspace from "@/platform/pages/JoinWorkspace";
import Team from "@/platform/app/Team";

function AppRoutes() {
  const location = useLocation();
  // Google OAuth return: detect the session_id fragment synchronously during
  // render (before any route guard) to avoid callback race conditions.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/app" replace />} />
      <Route path="/signup" element={<PublicOnlyRoute><Signup /></PublicOnlyRoute>} />
      <Route path="/login" element={<PublicOnlyRoute><Login /></PublicOnlyRoute>} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/account" element={<Account />} />
      <Route path="/workspace" element={<ProtectedRoute><Workspace /></ProtectedRoute>} />
      <Route path="/app" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route index element={<Overview />} />
        <Route path="projects" element={<Overview />} />
        <Route path="projects/:projectId" element={<ProjectView />} />
        <Route path="inbox" element={<Inbox />} />
        <Route path="team" element={<Team />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="settings" element={<Placeholder title="Settings" subtitle="Workspace and profile settings will live here." />} />
      </Route>
      <Route path="/forgot" element={<Forgot />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/demo/*" element={<DemoHarness />} />
      <Route path="/r/:token" element={<ReviewerEntry />} />
      <Route path="/join/:token" element={<JoinWorkspace />} />
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
